const utils = require('../../../lib/utils')

module.exports = {
	config: {
		focusAble: true
	},

	model: {
		initialized: false, // has this element's config been initialized or not
		dataJSON: {
			// from: '08:00',
			// to: '17:00'
		},
		absolutes: {
			fromTIME: 0,
			toTIME: 0
		},
		config: {
			isActivated: false,
			isOptional: false,
			disabled: false,
			separatedFieldCodes: {
				fromTIME: 'from',
				toTIME: 'to'
			},
			defaultFromTIME: '',
			defaultToTIME: '',
			time: {
				timeParts: ['hours', 'minutes'], // ['hours', 'minutes', 'seconds', 'milliseconds']
				timeRange: {
					// min: '08:30:00.000',
					// max: '17:00:00.000'
				},
				// maxExclusive: false,
				// hours: {
				// 	stepSize: 1,
				// 	beforeSymbol: ''
				// },
				// minutes: {
				// 	stepSize: 15,
				// 	beforeSymbol: ':'
				// }
			}
		}
	},

	events: {
		toggleOptional: {
			type: 'click',
			action: function(event) {
				const self = event.data.component
				const fieldConfig = self.model.config || {}

				if(fieldConfig.isOptional){
					const $select = $(event.target).closest('select')
					if($select.length > 0) return;

					const activationToggle = getComponent(self.$.find('[data-field-code="activated"]'), true)
					if(activationToggle) activationToggle.toggle();
				}
			}
		},
	},

	methods: {
		prepare(){
			this.initConfig()
		},

		initConfig(){
			if(this.model.initialized) return;
			this.model.initialized = true

			const fieldConfig = this.model.config || {}
			const separatedFieldCodes = fieldConfig.separatedFieldCodes || {}

			// set activated toggle if necessary
			if(fieldConfig.isOptional && !fieldConfig.isActivated && this.model.dataJSON){
				for(const fC in separatedFieldCodes){
					fieldConfig.isActivated = fieldConfig.isActivated || !!this.model.dataJSON[separatedFieldCodes[fC]]
				}
			}

			// set time-pickers disabled too if necessary
			fieldConfig.time.disabled = fieldConfig.disabled

			fieldConfig.emptyDataJSON = {}
			let fC, foreignFieldCode
			for(fC in separatedFieldCodes){
				foreignFieldCode = separatedFieldCodes[fC]
				fieldConfig.emptyDataJSON[foreignFieldCode] = null
			}

			// prevent undefined separationFieldCodes in dataJSON
			this.model.dataJSON = {
				...fieldConfig.emptyDataJSON,
				...(this.model.dataJSON || {})
			}
		},

		change: function(options){
			const fieldConfig = this.model.config || {}
			let optionalChanged = false
			let valueChanged = false
			let postponeValueChange = false
			let foreignFieldCode

			if(options.fieldCode === 'activated'){
				if(fieldConfig.isOptional) {
					optionalChanged = fieldConfig.isActivated !== !!options.value
					fieldConfig.isActivated = !!options.value
				}
			} else if((foreignFieldCode = fieldConfig.separatedFieldCodes[options.fieldCode])){
				valueChanged = this.model.dataJSON[foreignFieldCode] !== options.value
				this.model.dataJSON[foreignFieldCode] = options.value
				this.model.absolutes[options.fieldCode] = (options.additionals || {}).absoluteTime || 0
				if(this.model.absolutes.fromTIME > this.model.absolutes.toTIME && this.model.timePickerComponents){
					if(options.fieldCode === 'toTIME'){
						if(this.model.timePickerComponents.fromTIME.config.isReady){
							postponeValueChange = true
							this.model.timePickerComponents.fromTIME.setTime(options.value)
						}
					} else {
						if(this.model.timePickerComponents.toTIME.config.isReady){
							postponeValueChange = true
							this.model.timePickerComponents.toTIME.setTime(options.value)
						}
					}
				}
			}

			// change necessary?
			if(!fieldConfig.isOptional || optionalChanged || fieldConfig.isActivated){
				let options = {
					fieldCode: this.model.fieldCode,
					value: this.model.dataJSON
				}

				let tpc
				if(fieldConfig.isOptional){
					if(fieldConfig.isActivated){
						if(optionalChanged){
							for(tpc in this.model.timePickerComponents){
								this.model.timePickerComponents[tpc].enable()
							}
						}
					} else {
						if(optionalChanged){
							for(tpc in this.model.timePickerComponents){
								this.model.timePickerComponents[tpc].disable()
							}
						}

						options = {
							fieldCode: this.model.fieldCode,
							value: fieldConfig.emptyDataJSON
						}
					}
				}

				if((valueChanged && !postponeValueChange) || optionalChanged){
					// tell parent form that this field(s) has been changed
					this.parent(parentComponent => {
						parentComponent.trigger('onChildChanged', options)
					})
				}
			}
		}
	},

	hooks: {
		attach: function($element, options){
			// init prepare list of timePickers if necessary
			if(!this.model.timePickerComponents){
				this.model.timePickerComponents = {}
				this.find('base_form_fields_time-picker', function(timePickerComponent){
					this.model.timePickerComponents[timePickerComponent.model.fieldCode] = timePickerComponent
				})
			}

			// get init time values if necessary
			if(!options.refresh){
				const fieldConfig = this.model.config || {}
				const separatedFieldCodes = fieldConfig.separatedFieldCodes || {}
				let fC, foreignFieldCode, time
				for(fC in separatedFieldCodes){
					foreignFieldCode = separatedFieldCodes[fC]
					if(this.model.timePickerComponents[fC]){
						time = this.model.timePickerComponents[fC].getTime()
						this.model.dataJSON[foreignFieldCode] = time.value
						this.model.absolutes[fC] = time.absoluteValue
					}
				}
			}
		},

		onChildChanged: function($element, options){
			this.change(options)
		}
	}
}